import React from "react";
// import "../styles/comingSoon.css";
import StaciaTextLogo from "../Assets/staciaTextLogo.png";
import ComingSoonIcon from "../Assets/formComingSoonIllu.png";
// import { calc } from "antd/es/theme/internal";
import { useNavigate } from "react-router-dom";

function ComingSoon() {
  const navigate = useNavigate();

  return (
    <div
      className="comingSoon-container"
      style={{
        width: "100%",
        height: "100vh",
        backgroundImage:
          "linear-gradient(to bottom, #dbe7ff, #f3f2f8, #fbfbfc)",
      }}
    >
      <div className="landingTopbar">
        <div
          style={{
            width: "33%",
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
          }}
          onClick={() => navigate("/")}
        >
          <div>
            <img src={StaciaTextLogo} alt="" />
          </div>
          <div
            className="hero-heading-gred-word"
            style={{
              fontFamily: "EuclidBold",
              fontSize: "28px",
              color: "#1B51BB",
            }}
          >
            FORMS
          </div>
        </div>
        <div className="landing-top-bar-options center-opts">
          {/* <div>Enterprise</div>
          <div>Pricing</div>
          <div>FAQ</div> */}
        </div>
        <div className="landing-top-bar-options">
          <div className="signInBtn" onClick={() => navigate("/signIn")}>
            Sign in
          </div>
          <div className="GetStartedBtn" onClick={() => navigate("/")}>
            Go Back
          </div>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          height: "calc(100vh - 6rem)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <div style={{ width: "25%" }}>
          <img
            src={ComingSoonIcon}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
            alt=""
          />
        </div>
        <div
          style={{
            color: "#8493B2",
            fontFamily: "EuclidMedium",
            fontSize: "1.5rem",
          }}
        >
          Bringing you our stacia forms soon....
        </div>
      </div>
    </div>
  );
}

export default ComingSoon;
